import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postSubmitOfferingTransaction } from '@arrived/api_v2';
import { OfferingTransaction, OfferingTransactionId } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { accountTradesQueryKeyFn, tradeQueryKeyFn, userTradesQueryKeyFn } from './trades.keys';

export function usePostSubmitTradeMutation(options?: UseMutationOptions<OfferingTransaction, OfferingTransactionId>) {
  const queryClient = useQueryClient();

  return useMutation((tradeId) => postSubmitOfferingTransaction(tradeId), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { id: tradeId, accountId, userId } = data;

      queryClient.invalidateQueries(tradeQueryKeyFn(tradeId));
      queryClient.invalidateQueries(userTradesQueryKeyFn(userId));
      queryClient.invalidateQueries(accountTradesQueryKeyFn(accountId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
